module.exports = __webpack_public_path__ + "img/Tick-Icon.dfdec560.png";